module.exports = __webpack_public_path__ + "img/home2.0e0a7a76.png";